import { useLaunchParams } from '@tma.js/sdk-react';

const DESKTOP_PLATFORMS = new Set(['tdesktop', 'macos', 'web', 'weba', 'webk']);

export const useIsDesktop = (): boolean => {
    const lp = useLaunchParams(true);
    return DESKTOP_PLATFORMS.has(lp.tgWebAppPlatform);
};
